export const mainurl = process.env.REACT_APP_MAINURL;
export const chatUrl = process.env.REACT_APP_CHATURL;

export const api = {
  getInqueries: `${mainurl}get_inqueries`,
  getFeedback: `${mainurl}get_product_feedback`,
  getStatus: `${mainurl}get_inquiry_status`,

  get_user_rating: `${mainurl}v1/products/get_user_rating`,
  update_payment_method: `${mainurl}v1/users/update_payment_method`,
  // loginuserhistory
  get_login_logs: `${mainurl}v1/users/get_login_logs`,
  save_login_logs: `${mainurl}v1/users/save_login_logs`,

  get_wallet: `${mainurl}v1/wallets/get_wallet_by_admin`,
  get_wallet_for_admin: `${mainurl}get_wallet_for_admin`,
  get_pending_requests: `${mainurl}get_pending_requests`,

  get_agents: `${mainurl}get_realtor`,
  getCompany: `${mainurl}get_companies`,
  getTypes: `${mainurl}get_property_types`,
  getSaleType: `${mainurl}get_sale_type_method`,
  getConstructionStatus: `${mainurl}get_construction_status`,
  getAreaUnit: `${mainurl}get_area_unit`,
  getSortBy: `${mainurl}get_sortby`,
  UpdateUserStatus: `${mainurl}company_user_status_update`,
  getBusinesses: `${mainurl}get_property_external`,
  getOffers: `${mainurl}getbusinessoffers`,

  sendNotification: `${mainurl}sendnotification`,
  approveProperty: `${mainurl}approved_property`,
  approveRealtor: `${mainurl}approved_realtor`,
  approveOffers: `${mainurl}approve-businessoffers`,
  getbusinessoffers: `${mainurl}getbusinessoffers`,
  createAgent: `${mainurl}register`, //get-dashboard
  getDashboard: `${mainurl}v1/admin_dashboard`, //get-dashboard,
  getRequests: `${mainurl}get_inquiry`,
  getDocuments: `${mainurl}get_documents`,
  uploadDocument: `${mainurl}save_documents`,
  getHelp: `${mainurl}get-help`,
  saveHelp: `${mainurl}save-help`,
  getHelpCateogries: `${mainurl}get-categories`,
  getDocumentType: `${mainurl}get-document-type`,
  markasread: `${mainurl}editrequest`,
  getPosts: `${mainurl}get_posts`,
  postApprove: `${mainurl}update_posts_status`,
  sendEmail: `${mainurl}sendemail`,
  allseen: `${mainurl}all_seen`,
  //ROLE PERMISSIONS
  getRoles: `${mainurl}v1/role_permission/get_role_permission_and_types`,
  get_permissions: `${mainurl}v1/role_permission/get_permissions`,
  roles: `${mainurl}v1/role_permission/roles`,
  add_role_with_per_and_type: `${mainurl}v1/role_permission/add_role_with_per_and_type`,
  delete_roles: `${mainurl}v1/role_permission/delete_roles`,
  saveProfile: `${mainurl}allowed_realtors_edit`,
  updateProfile: `${mainurl}v1/users/update_profile`,
  replyInqueries: `${mainurl}inquiry_reply_email`,
  inquiresStatusChange: `${mainurl}inquiry_status_change`,
  getRoleNames: `${mainurl}v1/role_permission/get_roles`,
  get_profile_role: `${mainurl}v1/users/get_profile_role`,
  getRoleSignUp: `${mainurl}v1/role_permissions/get_roles`,
  assignRole: `${mainurl}v1/role_permission/assign_role`,
  status: `${mainurl}status`,
  change_wallet_status: `${mainurl}change_wallet_status`,
  reservation_status_change: `${mainurl}reservation_status_change`,
  terminateadmin: `${mainurl}team_status_change`,
  resend_access: `${mainurl}resend_access`,
  admin_logout: `${mainurl}admin_logout`,
  user_roles: `${mainurl}user_roles`,
  //SideBar and Permission
  sideBar: `${mainurl}v1/role_permission/get_role_permission_by_user`,
  //team_status_change
  getDocumentType: `${mainurl}get-document-type`,
  // get-document-type
  //CITY AND STATES SEARCHABLE
  getcityandstates: `${mainurl}getcityandstates`,
  //Business Category
  getPropertyCategories: `${mainurl}get_categories`,
  // offer freq nd types
  getoffertype: `${mainurl}getoffertype`,
  getofferfrequency: `${mainurl}getofferfrequency`, //get-categories
  getUsersdocuments: `${mainurl}accept_user_list_documents`,
  getCategories: `${mainurl}get-categories`,
  get_event_logs: `${mainurl}get_event_logs`,
  getbusinessesbyid: `${mainurl}getbusinessesbyid`,
  getFeatures: `${mainurl}get_about`,
  delete_report_pictures: `${mainurl}delete_report_pictures`,
  user_terminate: `${mainurl}user_terminate`,
  property_realtor_change: `${mainurl}property_realtor_change`,
  save_property_history: `${mainurl}save_property_history`,
  company_realtor_edit: `${mainurl}company_realtor_edit`,
  get_property_types: `${mainurl}get_property_types`,
  get_construction_status: `${mainurl}get_construction_status`,
  upload_property_images: `${mainurl}upload_property_images`,
  save_properties: `${mainurl}save_properties`,
  upload_property_documents: `${mainurl}upload_property_documents`,
  get_company_contacts: `${mainurl}get_company_contacts`,
  save_company_contacts: `${mainurl}save_company_contacts`,
  delete_company_contacts: `${mainurl}delete_company_contacts`,
  save_property_comments: `${mainurl}save_property_comments`,
  get_property_comments: `${mainurl}get_property_comments`,
  delete_property_comments: `${mainurl}delete_property_comments`,
  allowed_realtors: `${mainurl}allowed_realtors_edit`,
  edit_property_documents: `${mainurl}edit_property_documents`,
  updateforgotpassword: `${mainurl}v1/users/change_forgot_password`,
  sendforgotpasswordweb: `${mainurl}sendforgotpasswordweb`,
  send_forgot_password: `${mainurl}v1/users/forgot_password`,
  check_code_validity: `${mainurl}check_code_validity`,
  getProperties: `${mainurl}get_listings`,
  // get_property_status: `${mainurl}get_property_status`, //update_listing_status
  update_listing_status: `${mainurl}update_listing_status`, //update_listing_status
  get_reservation_history: `${mainurl}get_reservation_history`, //update_listing_status
  delete_reservation: `${mainurl}delete_reservation`,
  // get_transactions: `${mainurl}get_transactions`, //update_listing_status
  verify_forgot_password: `${mainurl}v1/users/verify_forgot_password`,
  otp_verify: `${mainurl}v1/users/verify_otp`,
  update_company_info: `${mainurl}v1/users/update_company_info`,
  // BRAND
  get_product_brand: `${mainurl}v1/products/get_brands`,
  add_product_brand: `${mainurl}v1/products/add_product_brand`,
  edit_product_brand: `${mainurl}v1/products/edit_product_brand`,
  delete_product_brand: `${mainurl}v1/products/delete_product_brand`,
  // COLOR
  get_color: `${mainurl}v1/products/get_colors`,
  add_color: `${mainurl}v1/products/add_product_color`,
  edit_color: `${mainurl}v1/products/edit_product_color`,
  delete_color: `${mainurl}v1/products/delete_product_color`,
  // SIZES
  get_sizes: `${mainurl}v1/products/get_sizes`,
  add_sizes: `${mainurl}v1/products/add_product_size`,
  edit_sizes: `${mainurl}v1/products/edit_product_size`,
  delete_sizes: `${mainurl}v1/products/delete_product_size`,
  // CONDITION
  get_conditions: `${mainurl}v1/products/get_conditions`,
  add_conditions: `${mainurl}v1/products/add_product_condition`,
  edit_conditions: `${mainurl}v1/products/edit_product_condition`,
  delete_conditions: `${mainurl}v1/products/delete_product_condition`,
  // CATEGORIES
  get_categories: `${mainurl}v1/products/get_categories_for_admin`,
  // get_categories: `${mainurl}v1/products/get_categories`,
  get_parent_categories: `${mainurl}v1/products/get_categories_for_dropdown`,
  add_categories: `${mainurl}v1/products/add_product_category`,
  edit_categories: `${mainurl}v1/products/edit_product_category`,
  delete_categories: `${mainurl}v1/products/delete_product_category`,

  // PRODUCTS
  get_products: `${mainurl}v1/products/get_products`,
  get_product_status: `${mainurl}v1/products/get_product_status`,
  change_product_status: `${mainurl}v1/products/action_product_status`,
  get_product_offers: `${mainurl}v1/products/get_product_offers_by_product`,
  bulk_product_change: `${mainurl}v1/products/bulk_product_change`,
  // ORDERS
  get_orders: `${mainurl}v1/products/get_orders`,
  //USERS
  get_user_status: `${mainurl}v1/users/get_user_statuses`,
  update_user_status: `${mainurl}v1/users/action_user_status`,
  change_password_by_admin: `${mainurl}v1/users/change_password_by_admin`,
  //FAQ CATEGORY
  get_faq_category: `${mainurl}v1/faqs/get_faqs_categories`,
  add_faq_category: `${mainurl}v1/faqs/add_faqs_categories`,
  edit_faq_category: `${mainurl}v1/faqs/edit_faqs_categories`,
  delete_faq_category: `${mainurl}v1/faqs/delete_faqs_categories`,
  //TRANSACTIONS
  get_transactions: `${mainurl}v1/wallets/get_wallet_details`,
  get_transactions_status: `${mainurl}v1/wallets/get_wallet_status`,
  //FAQS
  get_faqs: `${mainurl}v1/faqs/get_faqs`,
  add_faq: `${mainurl}v1/faqs/add_faqs`,
  edit_faq: `${mainurl}v1/faqs/edit_faqs`,
  delete_faq: `${mainurl}v1/faqs/delete_faqs`,
  //FEEDBACK & BUGS
  get_feedback: `${mainurl}v1/feedback/get_feedbacks`,
  reply_feedback: `${mainurl}v1/feedback/feedback_reply_email`,
  get_bugs: `${mainurl}v1/feedback/get_feedbacks`,
  reply_bug: `${mainurl}v1/feedback/feedback_reply_email`,
  bug_status_change: `${mainurl}v1/feedback/feedback_status_change`,
  get_bug_status: `${mainurl}v1/feedback/get_bug_status`,
  //REQUEST WITHDRAWAL
  get_withdrawal_request: `${mainurl}v1/wallets/get_requests`,
  get_withdraw_request_status: `${mainurl}v1/wallets/get_withdraw_request_status`,
  request_status_change: `${mainurl}v1/wallets/request_status_change`,
  add_content: `${mainurl}v1/content/add_content`,
  get_contents: `${mainurl}v1/content/get_contents`,
  edit_content: `${mainurl}v1/content/edit_content`,
  // Banner
  get_banners: `${mainurl}v1/products/get_banners`,
  delete_banner: `${mainurl}v1/products/delete_banner`,
  edit_banner: `${mainurl}v1/products/edit_banner`,
  add_banner: `${mainurl}v1/products/add_banner`,
  // Protection fee
  get_buyer_protection_fee: `${mainurl}v1/buyer_protection_fee/get_buyer_protection_fee`,
  add_buyer_protection_fee: `${mainurl}v1/buyer_protection_fee/add_buyer_protection_fee`,
  delete_buyer_protection_fee: `${mainurl}v1/buyer_protection_fee/delete_buyer_protection_fee`,
  edit_buyer_protection_fee: `${mainurl}v1/buyer_protection_fee/edit_buyer_protection_fee`,
  // Delivery fee
  add_delivery_fee: `${mainurl}v1/delivery_fee/add_delivery_fee`,
  edit_delivery_fee: `${mainurl}v1/delivery_fee/edit_delivery_fee`,
  get_delivery_fee: `${mainurl}v1/delivery_fee/get_delivery_fee`,
  delete_delivery_fee: `${mainurl}v1/delivery_fee/delete_delivery_fee`,
  // OrderDiscountCoupon
  get_discount_order: `${mainurl}v1/discount_order/get_discount_order`,
  add_discount_order: `${mainurl}v1/discount_order/add_discount_order`,
  edit_discount_order: `${mainurl}v1/discount_order/edit_discount_order`,
  delete_discount_order: `${mainurl}v1/discount_order/delete_discount_order`,
  // Refund Request
  get_refund_request: `${mainurl}v1/wallets/get_refund_request`,
  action_refund_request: `${mainurl}v1/wallets/action_refund_request`,
  //EARNINGS
  get_earnings: `${mainurl}v1/products/get_earnings`,

  //auth
  reset_password: `${mainurl}v1/users/change_password`,
  login: `${mainurl}v1/users/login`,
  register: `${mainurl}v1/users/sign_up`,
  sign_up_with_email_password: `${mainurl}v1/users/sign_up_with_email_password`,
  getUsers: `${mainurl}v1/users/get_users`,
  create_user: `${mainurl}v1/users/create_user`,
  resend_otp: `${mainurl}v1/users/resend_otp`,
  change_email_otp: `${mainurl}v1/users/change_email_otp`,
  change_email: `${mainurl}v1/users/change_email`,
  get_profiles: `${mainurl}v1/users/get_profiles`,

  //logistic web

  //shipments
  get_my_shipment: `${mainurl}v1/shipment/get_my_shipment`,
  get_companies: `${mainurl}v1/shipment/get_companies`,
  add_edit_contact_list: `${mainurl}v1/contact_list/add_edit_contact_list`,
  save_shipment: `${mainurl}v1/shipment/save_shipment`,
  get_shipment: `${mainurl}v1/shipment/get_shipment`,
  extend_pickup_date_shipment: `${mainurl}v1/shipment/extend_pickup_date_shipment`,
  change_shipment_status: `${mainurl}v1/shipment/change_shipment_status`,
  change_bulk_shipment_status: `${mainurl}v1/shipment/change_bulk_shipment_status`,
  action_on_bid_request: `${mainurl}v1/shipment/action_on_bid_request`,
  get_saved_shipment: `${mainurl}v1/shipment/get_saved_shipment`,
  mark_as_complete: `${mainurl}v1/shipment/mark_as_complete`,
  get_marketrates: `${mainurl}v1/shipment/get_marketrates`,
  get_truck_marketrates: `${mainurl}v1/truck/get_truck_marketrates`,
  get_shipment_companies: `${mainurl}v1/shipment/get_shipment_companies`,
  upload_document: `${mainurl}v1/shipment/upload_document`,
  get_documents: `${mainurl}v1/shipment/get_documents`,
  get_document_type: `${mainurl}v1/shipment/get_document_type`,
  delete_document: `${mainurl}v1/shipment/delete_document`,
  get_request_a_truck: `${mainurl}v1/shipment/get_request_a_truck`,
  send_invitation: `${mainurl}v1/shipment/send_invitation`,
  get_invitation: `${mainurl}v1/shipment/get_invitation`,
  get_shipment_by_id: `${mainurl}v1/shipment/get_shipment_by_id`,
  get_messages: `${mainurl}v1/shipment/get_messages`,
  send_message: `${mainurl}v1/shipment/send_message`,
  accept_invitation: `${mainurl}v1/shipment/accept_invitation`,
  get_group_list: `${mainurl}v1/group/get_group_list`,

  //search load
  search_load: `${mainurl}v1/shipment/search_load`,
  my_load: `${mainurl}v1/shipment/my_load`,

  //dashborad
  dashboard: `${mainurl}v1/shipment/dashboard`,
  get_user_by_id: `${mainurl}v1/users/get_user_by_id`,
  cancel_subscription: `${mainurl}v1/subscription/cancel_subscription`,
  get_subscriptions: `${mainurl}v1/subscription/get_subscriptions`,

  //trucks
  get_equipments: `${mainurl}v1/truck/get_equipments`,
  get_commodities: `${mainurl}v1/commodity/get_commodities`,
  get_contact_list: `${mainurl}v1/contact_list/get_contact_list`,
  save_truck: `${mainurl}v1/truck/save_truck`,
  get_trucks: `${mainurl}v1/truck/get_trucks`,
  change_truck_status: `${mainurl}v1/truck/change_truck_status`,
  change_bulk_truck_status: `${mainurl}v1/truck/change_bulk_truck_status`,
  search_truck: `${mainurl}v1/truck/search_truck`,
  get_truck_by_id: `${mainurl}v1/truck/get_truck_by_id`,
  get_request_a_shipment: `${mainurl}v1/truck/get_request_a_shipment`,

  // private networkl
  save_contact: `${mainurl}v1/private_network/save_contact`,
  get_contacts: `${mainurl}v1/private_network/get_contacts`,
  delete_contact: `${mainurl}v1/private_network/delete_contact`,
  get_groups: `${mainurl}v1/private_network/get_groups`,
  get_group_by_id: `${mainurl}v1/private_network/get_group_by_id`,
  add_contacts_in_new_group: `${mainurl}v1/private_network/add_contacts_in_new_group`,
  add_contacts_in_existing_group: `${mainurl}v1/private_network/add_contacts_in_existing_group`,
  delete_group: `${mainurl}v1/private_network/delete_group`,

  // GET SHIPMENT REQUEST
  get_truck_bid_request: `${mainurl}v1/shipment/get_truck_bid_request`,
  get_truck_shipment_bid_request: `${mainurl}v1/shipment/get_truck_shipment_bid_request`,
  update_truck_bid_status: `${mainurl}v1/shipment/update_truck_bid_status`,

  //Bid request
  get_my_bid_request: `${mainurl}v1/shipment/get_my_bid_request`,
  bid_placed: `${mainurl}v1/shipment/bid_placed`,
  truck_bid_placed: `${mainurl}v1/shipment/truck_bid_placed`,
  get_shipment_bid_request: `${mainurl}v1/shipment/get_shipment_bid_request`,
  mark_as_save_shipment: `${mainurl}v1/shipment/mark_as_save_shipment`,
  save_booking: `${mainurl}v1/shipment/bid_placed`,
  get_company_list: `${mainurl}v1/shipment/get_company_list`,
  action_block_unblock: `${mainurl}v1/shipment/action_block_unblock`,
  get_reviews: `${mainurl}v1/shipment/get_reviews`,
  get_packages: `${mainurl}v1/subscription/get_packages`
};
